var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "team_icon",
    "data-name": "team icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-people-carry",
    "data-name": "Icon awesome-people-carry",
    d: "M3.056,2.293A1.146,1.146,0,1,0,1.91,1.146,1.147,1.147,0,0,0,3.056,2.293Zm9.17,0A1.146,1.146,0,1,0,11.08,1.146,1.147,1.147,0,0,0,12.226,2.293Zm3,8.886L14.177,8.552,13.2,9.66l-.048.435.661,1.653a.764.764,0,0,0,.709.48.742.742,0,0,0,.284-.055A.764.764,0,0,0,15.228,11.178Zm-.817-5.01-.442-1.915a1.548,1.548,0,0,0-.9-1.072,1.473,1.473,0,0,0-1.34.079,2.616,2.616,0,0,0-1.149,1.419l-.27.81-.382.244V3.439a.383.383,0,0,0-.382-.382H5.731a.383.383,0,0,0-.382.382V5.731l-.384-.244-.27-.81A2.6,2.6,0,0,0,3.546,3.26a1.474,1.474,0,0,0-1.34-.079,1.548,1.548,0,0,0-.9,1.072L.871,6.168a1.53,1.53,0,0,0,.344,1.354l1.6,1.813.241,2.211a.765.765,0,0,0,.759.681c.029,0,.055,0,.084,0a.763.763,0,0,0,.676-.843L4.338,9.163a1.526,1.526,0,0,0-.373-.836L2.932,7.157l.42-1.679.162.487a1.544,1.544,0,0,0,.585.779l1.22.776a1.017,1.017,0,0,0,.411.119H9.552a1.017,1.017,0,0,0,.411-.119l1.22-.776a1.535,1.535,0,0,0,.585-.779l.162-.487.42,1.679-1.034,1.17a1.526,1.526,0,0,0-.373.836L10.7,11.379a.765.765,0,0,0,.676.843c.029,0,.055,0,.084,0a.765.765,0,0,0,.759-.681l.241-2.211,1.6-1.813a1.537,1.537,0,0,0,.344-1.354ZM1.1,8.552.054,11.178a.764.764,0,1,0,1.419.568l.661-1.653L2.086,9.66,1.1,8.552Z",
    transform: "translate(2.359 3.859)",
    fill: "#697482"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 20,
    height: 20,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/team-icon.0e158969ae84cbf495b0dbc70c85c3fc.svg";
export { ForwardRef as ReactComponent };